import styled from 'styled-components'
import Box from '@fuegokit/react/components/Box'
import sx, {SxProp} from '@fuegokit/react/sx'
import {gridSpaceSizes} from '@fuegokit/react/components/Stack/constants'
import {BaseStackProps} from './types'

const justifyContentMappings: {[position: string]: string} = {
  center: 'center',
  start: 'flex-start',
  end: 'flex-end',
  between: 'space-between'
}

export const NonRecursiveStack = styled(Box)<BaseStackProps & SxProp>`
  display: flex;
  width: 100%;
  height: ${p => (p.direction === 'column' ? 'auto' : 'revert')};
  flex-direction: ${p => (p.direction === 'column' ? 'column' : 'row')};
  justify-content: ${p => justifyContentMappings[p.justify as string] || 'revert'};
  align-items: ${p => justifyContentMappings[p.justify as string] || 'revert'};
  & > * + * {
    margin-block-start: ${p => (p.direction === 'column' ? `${gridSpaceSizes[p.size]}px` : 'revert')};
    margin-inline-start: ${p => (p.direction === 'row' ? `${gridSpaceSizes[p.size]}px` : 'revert')};
  }

  ${sx}
`
export const RecursiveStack = styled(Box)<BaseStackProps & SxProp>`
  width: 100%;
  height: ${p => (p.direction === 'column' ? 'auto' : 'revert')};
  display: flex;
  flex-direction: ${p => (p.direction === 'column' ? 'column' : 'row')};
  gap: ${p => (p.direction === 'row' ? `${gridSpaceSizes[p.size]}px` : 'revert')};
  justify-content: ${p => justifyContentMappings[p.justify as string] || 'revert'};
  align-items: ${p => justifyContentMappings[p.justify as string] || 'revert'};

  & * + * {
    margin-block-start: ${p => (p.direction === 'column' ? `${gridSpaceSizes[p.size]}px` : 'revert')};
    margin-inline-start: ${p => (p.direction === 'row' ? `${gridSpaceSizes[p.size]}px` : 'revert')};
  }

  ${sx}
`
